export const abbrs_dotted: string[] = [
  'a.m.k.',
  'a.ö.l.',
  'ca.',
  'klst.',
  'm.a.',
  'm.t.t.',
  'nr.',
  'p.s.',
  'sbr.',
  'sl.',
  'stk.',
  't.d.',
  'v.',
  'þ.á.m.',
  'a.e.s.',
  'æ.v.',
  'a.l.',
  'a.l.l.',
  'c.d.',
  'c.v.',
  'dig.',
  'd.t.',
  'e.a.',
  'e.a.a.',
  'e.a.s.',
  'e.o.',
  'e.s.',
  'e.t.',
  'e.t.v.',
  'g.s.',
  'g.v.',
  'h.g.',
  'i.a.',
  'i.s.',
  'i.t.',
  'i.v.',
  'k.r.',
  'm.k.',
  'm.l.d.',
  'p.o.',
  's.c.',
  'sek.',
  'sin.',
  'sj.',
  't.i.v.',
  't.o.m.',
  'vi.',
];
